import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "table-with-outer-filter" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterFactory = _resolveComponent("FilterFactory")!
  const _component_TableComponent = _resolveComponent("TableComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_FilterFactory, {
      filtersConfig: _ctx.filtersConfig,
      defaultFilter: _ctx.defaultFilter,
      onSearchFilter: _ctx.searchFilter,
      onUpdateFilter: _ctx.updateFilter,
      onResetFilter: _ctx.onResetFilter,
      hasActiveSort: Boolean(_ctx.sortParams),
      isShowResetButton: !_ctx.isLifeSync,
      isShowApplyButton: !_ctx.isLifeSync,
      selectButtonText: _ctx.selectButtonText
    }, {
      buttons: _withCtx(() => [
        _renderSlot(_ctx.$slots, "filter-buttons", { filter: _ctx.getSlotFilter }, undefined, true)
      ]),
      _: 3
    }, 8, ["filtersConfig", "defaultFilter", "onSearchFilter", "onUpdateFilter", "onResetFilter", "hasActiveSort", "isShowResetButton", "isShowApplyButton", "selectButtonText"]),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    _createVNode(_component_TableComponent, {
      ref: "tableComponent",
      tableClass: _ctx.tableClass,
      columns: _ctx.tableConfig.columns,
      params: _ctx.getTableParams,
      storePaths: _ctx.tableConfig.storePaths,
      isShowNumberColumn: _ctx.tableConfig.isShowNumberColumn,
      eventConfigs: _ctx.tableConfig.eventConfigs,
      pagination: _ctx.tableConfig.pagination,
      emptyText: _ctx.tableConfig.emptyText,
      rowClass: _ctx.tableConfig.rowClass,
      onSortChange: _ctx.onSortChange
    }, {
      numberSuffix: _withCtx((slotProps) => [
        _renderSlot(_ctx.$slots, "numberSuffix", _normalizeProps(_guardReactiveProps(slotProps)), undefined, true)
      ]),
      _: 3
    }, 8, ["tableClass", "columns", "params", "storePaths", "isShowNumberColumn", "eventConfigs", "pagination", "emptyText", "rowClass", "onSortChange"])
  ]))
}